.title {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-weight: var(--weight-medium);
  color: var(--text-primary);
  min-width: 0;
}

.titleText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 34ch;
}

.identifier {
  font-family: var(--font-mono);
  font-size: var(--text-xs);
  color: var(--text-tertiary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 22ch;
}

.muted {
  color: var(--text-tertiary);
}

.score {
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
}

.chevron {
  color: var(--text-tertiary);
}

/* ---- Card list, used instead of the table on narrow viewports ---- */
.cards {
  display: flex;
  flex-direction: column;
}

.card {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  padding: var(--space-4) var(--space-5);
  border-bottom: 1px solid var(--border-subtle);
  text-align: left;
  transition: background var(--duration-fast) var(--ease-out);
}

.card:last-child {
  border-bottom: none;
}

.card:hover {
  background: var(--bg-hover);
}

.cardBody {
  flex: 1;
  min-width: 0;
}

.cardTitle {
  font-weight: var(--weight-medium);
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cardMeta {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-3);
  margin-top: var(--space-1);
  font-size: var(--text-xs);
  color: var(--text-tertiary);
}

.cardTags {
  display: flex;
  gap: var(--space-2);
  margin-top: var(--space-2);
}

.skipped {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-4);
  font-size: var(--text-sm);
  color: var(--text-tertiary);
  border-top: 1px solid var(--border-subtle);
  background: var(--bg-inset);
}
